import {
  AreaFragmentDto,
  FrameDto,
  FrameOverlaysDto,
  FrameVariation,
  RoofTrimDto,
  SectionFragmentDto,
  SectionFragmentType
} from "@hec/api-dtos";
import {DormerRootState} from "../DormerRootState";
import {createSelector} from "@reduxjs/toolkit";

export const getSelectableSectionFragmentsSelector = (state: DormerRootState): SectionFragmentDto[] => {
  return state.selectableSectionFragments.selectableSectionFragments;
}

export const getSelectableFramesSelector = createSelector(
  [getSelectableSectionFragmentsSelector],
  (fragments) =>
    fragments.filter(x => x.sectionFragmentType === SectionFragmentType.Frame) as FrameDto[]
);

export const getSelectableAreaFragmentSelector = (state: DormerRootState): AreaFragmentDto[] => {
  return getSelectableSectionFragmentsSelector(state).filter(x=> x.sectionFragmentType === SectionFragmentType.AreaFragment) as AreaFragmentDto[];
}

export const getDefaultFrameSelector = (state: DormerRootState): FrameDto | null => {
  if (state.selectableSectionFragments.selectableSectionFragments !== null) {
    const selectable = getSelectableFramesSelector(state)
      .filter((frame: FrameDto) => frame.isDefaultForTemplate);


    const window = selectable.find(x => x.variation === FrameVariation.Window);
    if(window) {
      return window;
    }

    const nonPanel = selectable.find(x => x.variation !== FrameVariation.Panel);

    return nonPanel ?? selectable.find(x=> !!x) ?? null;
  }
  return null;
}

export const getDefaultAreaFragment = (state: DormerRootState): AreaFragmentDto | null => {
  if (state.selectableSectionFragments.selectableSectionFragments !== null) {
    const selectable = getSelectableAreaFragmentSelector(state)
      .filter((frame: AreaFragmentDto) => frame.isDefaultForTemplate);

    return selectable.find(x=> !!x) ?? null;
  }
  return null;
}


export const getSelectableRoofTrimSelector = (state: DormerRootState): RoofTrimDto[] => {
  return getSelectableSectionFragmentsSelector(state).filter(x=> x.sectionFragmentType === SectionFragmentType.RoofTrim && x.isUserSelectable === true) as FrameDto[];
}

export const getSelectableFrameOverlaySelector = (state: DormerRootState): FrameOverlaysDto[] => {
  return getSelectableSectionFragmentsSelector(state).filter(x=> x.sectionFragmentType === SectionFragmentType.FrameOverlay && x.isUserSelectable === true) as FrameDto[];
}
